import {
  CHAT_COMPANY_FETCH_CHATS_SUCCESS,
  CHAT_COMPANY_ADD_CHATS_SUCCESS,
  CHAT_COMPANY_ADD_NEW_CHAT_SUCCESS,
  CHAT_COMPANY_REPLACE_OR_ADD_CHAT_SUCCESS,
  CHAT_COMPANY_SET_LOADING,
  CHAT_PROJECT_ADD_CHATS_SUCCESS,
  CHAT_PROJECT_ADD_NEW_CHAT_SUCCESS,
  CHAT_PROJECT_REPLACE_OR_ADD_CHAT_SUCCESS,
  CHAT_PROJECT_FETCH_CHATS_SUCCESS,
  CHAT_PROJECT_SET_LOADING,
  CHAT_CURRENT_MESSAGES_SET_LOADING,
  CHAT_CURRENT_MESSAGES_ADD_SUCCESS,
  CHAT_CURRENT_MESSAGES_FETCH_SUCCESS,
  CHAT_CURRENT_MESSAGES_SEND_SUCCESS,
  CHAT_CURRENT_MESSAGES_NEW_SUCCESS,
  CHAT_ACTIVE_SET,
  CHAT_COMPANY_UPDATE_USER_READ_COUNT_SUCCESS,
  CHAT_PROJECT_UPDATE_USER_READ_COUNT_SUCCESS,
  CHAT_ACTIVE_UPDATE_USER_READ_COUNT,
} from './constants';
import { EventTypes } from 'redux-segment';
import _cloneDeep from 'lodash.clonedeep';
import {
  dashboardIncCompanyNewMessagesCount,
  dashboardIncProjectsNewMessagesCountSuccess,
} from '../dashboard/actions';

export function chatProjectLoadChatsSuccess(data, isFirstPage) {
  return {
    type: isFirstPage ? CHAT_PROJECT_FETCH_CHATS_SUCCESS : CHAT_PROJECT_ADD_CHATS_SUCCESS,
    data,
  };
}

export function chatProjectAddNewChatSuccess(chat) {
  return {
    type: CHAT_PROJECT_ADD_NEW_CHAT_SUCCESS,
    chat,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatProjectAddOrReplaceChatSuccess(chat) {
  return {
    type: CHAT_PROJECT_REPLACE_OR_ADD_CHAT_SUCCESS,
    chat,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatProjectUpdateUserReadCount(chatUser) {
  return {
    type: CHAT_PROJECT_UPDATE_USER_READ_COUNT_SUCCESS,
    chatUser,
  };
}

export function chatProjectSetLoading(is) {
  return {
    type: CHAT_PROJECT_SET_LOADING,
    loading: is,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCompanyLoadChatsSuccess(data, isFirstPage) {
  return {
    type: isFirstPage ? CHAT_COMPANY_FETCH_CHATS_SUCCESS : CHAT_COMPANY_ADD_CHATS_SUCCESS,
    data,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCompanyAddNewChatSuccess(chat) {
  return {
    type: CHAT_COMPANY_ADD_NEW_CHAT_SUCCESS,
    chat,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCompanyAddOrReplaceChatSuccess(chat) {
  return {
    type: CHAT_COMPANY_REPLACE_OR_ADD_CHAT_SUCCESS,
    chat,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCompanyUpdateUserReadCount(chatUser) {
  return {
    type: CHAT_COMPANY_UPDATE_USER_READ_COUNT_SUCCESS,
    chatUser,
  };
}

export function chatCurrentMessagesAddSuccess(data, isFirstPage) {
  return {
    type: isFirstPage ? CHAT_CURRENT_MESSAGES_ADD_SUCCESS : CHAT_CURRENT_MESSAGES_FETCH_SUCCESS,
    data,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCurrentMessagesNewSuccess(data) {
  return {
    type: CHAT_CURRENT_MESSAGES_NEW_SUCCESS,
    data,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCurrentMessagesSetLoading(is) {
  return {
    type: CHAT_CURRENT_MESSAGES_SET_LOADING,
    loading: is,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCurrentMessagesSendSuccess(is) {
  return {
    type: CHAT_CURRENT_MESSAGES_SEND_SUCCESS,
    loading: is,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatCompanySetLoading(is) {
  return {
    type: CHAT_COMPANY_SET_LOADING,
    loading: is,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatActiveSet(chat) {
  return {
    type: CHAT_ACTIVE_SET,
    chat,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function chatActiveUpdateUserReadCount(chatUser) {
  return {
    type: CHAT_ACTIVE_UPDATE_USER_READ_COUNT,
    chatUser,
  };
}

export function fetchNewProjectChat(companyId, chatId) {
  return async (dispatch, getStore, services) => {
    try {
      const res = await services.api.clientChatGet(companyId, chatId);
      dispatch(chatProjectAddNewChatSuccess(res.data));
    } catch (err) {}
  };
}

export function fetchReplaceOrAddProjectChat(companyId, chatId) {
  return async (dispatch, getStore, services) => {
    try {
      const isTabActive = getStore().app.isTabActive;
      const activeChat = getStore().dashboard.chats.activeChat;
      const res = await services.api.clientChatGet(companyId, chatId);
      const fetchedChat = _cloneDeep(res.data);
      if (activeChat && activeChat._id === chatId) {
        if (isTabActive) {
          // Mitigate race condition around fetching chat data and updating read count when user sees active chat
          const diff = fetchedChat.chatUser.readCount - fetchedChat.totalMessages;
          if (diff < 0) {
            dispatch(dashboardIncProjectsNewMessagesCountSuccess(fetchedChat.projectId, diff));
            dispatch(dashboardIncCompanyNewMessagesCount(diff));
          }
          fetchedChat.chatUser.readCount = fetchedChat.totalMessages;
        }
        chatActiveSet(fetchedChat);
      }
      dispatch(chatProjectAddOrReplaceChatSuccess(fetchedChat));
    } catch (err) {}
  };
}

export function fetchNewCompanyChat(companyId, chatId) {
  return async (dispatch, getStore, services) => {
    try {
      let res;
      if (getStore().dashboard.company.type === 'client') {
        res = await services.api.clientChatGet(companyId, chatId);
      } else {
        res = await services.api.supplierChatGet(companyId, chatId);
      }
      dispatch(chatCompanyAddNewChatSuccess(res.data));
    } catch (err) {}
  };
}

export function fetchReplaceOrAddCompanyChat(companyId, chatId) {
  return async (dispatch, getStore, services) => {
    try {
      let res;
      const isTabActive = getStore().app.isTabActive;
      const activeChat = getStore().dashboard.chats.activeChat;
      if (getStore().dashboard.company.type === 'client') {
        res = await services.api.clientChatGet(companyId, chatId);
      } else {
        res = await services.api.supplierChatGet(companyId, chatId);
      }
      const fetchedChat = _cloneDeep(res.data);
      if (activeChat && activeChat._id === chatId) {
        if (isTabActive) {
          // Mitigate race condition around fetching chat data and updating read count when user sees active chat
          const diff = fetchedChat.chatUser.readCount - fetchedChat.totalMessages;
          if (diff < 0) {
            dispatch(dashboardIncProjectsNewMessagesCountSuccess(fetchedChat.projectId, diff));
            dispatch(dashboardIncCompanyNewMessagesCount(diff));
          }
          fetchedChat.chatUser.readCount = fetchedChat.totalMessages;
        }
        chatActiveSet(fetchedChat);
      }
      dispatch(chatCompanyAddOrReplaceChatSuccess(fetchedChat));
    } catch (err) {}
  };
}

export function fetchProjectChats(companyId, projectId, params, isFirstPage) {
  return async (dispatch, getStore, services) => {
    dispatch(chatProjectSetLoading(true));
    try {
      const res = await services.api.clientProjectChatsGet(companyId, projectId, params);
      dispatch(chatProjectLoadChatsSuccess(res.data, isFirstPage));
      dispatch(chatProjectSetLoading(false));
    } catch (err) {
      dispatch(chatProjectSetLoading(false));
    }
  };
}

export function fetchCompanyChats(companyId, companyType, params, isFirstPage) {
  return async (dispatch, getStore, services) => {
    dispatch(chatCompanySetLoading(true));
    try {
      const res =
        companyType === 'client'
          ? await services.api.clientAllChatsGet(companyId, params)
          : await services.api.supplierAllChatsGet(companyId, params);
      dispatch(chatCompanyLoadChatsSuccess(res.data, isFirstPage));
      dispatch(chatCompanySetLoading(false));
    } catch (err) {
      dispatch(chatCompanySetLoading(false));
    }
  };
}

export function fetchChatMessages(companyId, chatId, params) {
  return async (dispatch, getStore, services) => {
    dispatch(chatCurrentMessagesSetLoading(true));
    try {
      const res = await services.api.messagesGet(companyId, chatId, params);
      const activeChat = getStore().dashboard.chats.activeChat;
      if (!activeChat || chatId === activeChat._id) {
        dispatch(chatCurrentMessagesAddSuccess(res.data, params.isFirstPage));
      }
      dispatch(chatCurrentMessagesSetLoading(false));
    } catch (err) {
      dispatch(chatCurrentMessagesSetLoading(false));
    }
  };
}

export function sendChatMessage(chatId, data) {
  return async (dispatch, getStore, services) => {
    try {
      const res = await services.api.messagePost(chatId, data);
      dispatch(chatCurrentMessagesSendSuccess(res.data));
    } catch (err) {}
  };
}

export function changeActiveChat(chat) {
  return async (dispatch) => {
    dispatch(chatActiveSet(chat));
  };
}

/**
 * Update read count of messages if not all messages red
 *
 * @param chat
 * @param doNotUpdateGlobalCounters
 * @returns {Function}
 */
export function chatUpdateReadCount(chat, doNotUpdateGlobalCounters = false) {
  return async (dispatch, getStore, services) => {
    try {
      const isTabActive = getStore().app.isTabActive;
      const activeChat = getStore().dashboard.chats.activeChat;
      const prevReadCount = chat.chatUser.readCount;
      const res = await services.api.chatUserReadPut(chat._id);
      const inc = prevReadCount - res.data.readCount;
      if (inc < 0) {
        // Global counters are already updated by fetchReplaceOrAddCompanyChat or fetchReplaceOrAddProjectChat
        if (
          !isTabActive ||
          !activeChat ||
          activeChat._id !== chat._id ||
          !doNotUpdateGlobalCounters
        ) {
          dispatch(dashboardIncProjectsNewMessagesCountSuccess(chat.projectId, inc));
          dispatch(dashboardIncCompanyNewMessagesCount(inc));
        }
        dispatch(chatUpdateUserReadCountCheckAll(res.data));
      }
    } catch (err) {}
  };
}

export function chatUpdateUserReadCountCheckAll(chatUser) {
  return async (dispatch) => {
    dispatch(chatActiveUpdateUserReadCount(chatUser));
    dispatch(chatCompanyUpdateUserReadCount(chatUser));
    dispatch(chatProjectUpdateUserReadCount(chatUser));
  };
}



// WEBPACK FOOTER //
// ./src/container/chat/actions.js